var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgCaretLeft = function SvgCaretLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 11,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.02 9.856a.797.797 0 101.103-1.15L2.302 5.039l3.82-3.667A.797.797 0 105.02.222L0 5.039l5.02 4.817z",
    fill: "#A7A7A7"
  })));
};

export default SvgCaretLeft;